import { useReducer } from "react";
import api from "../api/organizations";

const intialState = {
  roles: [],
  persons: [],
  personroles: [],
  isPersonRolesLoaded: false
};

function reducer(state, action) {
  switch (action.type) {
    case "ROLES":
      return {
        ...state,
        roles: action.roles,
      };
    case "PERSON_ROLES":
      return {
        ...state,
        personroles: action.personroles,
        isPersonRolesLoaded: true
      };
    case "PERSONS":
      return {
        ...state,
        persons: action.persons,
      };
    default:
      return {
        ...state,
        ...action.payload
      };
  }
}

export default function useRoles() {
  const [dataSources, dispatch] = useReducer(reducer, intialState);

    function getRoles() {
        api.getRolesDict().then(({ data }) => {
            dispatch({
                type: "ROLES",
                roles: data,
            });
        })
    }

    function getPersonRoles(id) {
        api.getPersonRoles(id).then(({ data }) => {
            dispatch({
                type: "PERSON_ROLES",
                personroles: data,
            });
        })
    }

    function getPersons(orgId) {
        api.getOrganizationStaff(orgId).then(({ data }) => {
            dispatch({
                type: "PERSONS",
                persons: data,
            });
        })
    }

  return {
    dataSources,
    getRoles,
    getPersons,
    getPersonRoles
  };
}
